import { gql } from "@apollo/client";
import Grid from "atoms/Grid";
import useData from "helpers/useData";
import Section from "molecules/Section";
import React from "react";

import ReelCard, { ReelCardFragment } from "./ReelCard";

export const GameOverviewReelsFragment = gql`
  fragment GameOverviewReelsFragment on Game {
    id
  }
`;

export const GameOverviewReelsGamePlayerFragment = gql`
  fragment GameOverviewReelsGamePlayerFragment on GamePlayer {
    person {
      id
      fullNameWithAnonymisation
    }
  }
`;

export default function GameOverviewReels({ gamePlayer }) {
  const [data] = useData(
    gql`
      query GameOverviewReels($gamePlayerId: ID!) {
        gamePlayer(id: $gamePlayerId) {
          id
          reelViews {
            id
            ...ReelCardFragment
          }
        }
      }
      ${ReelCardFragment}
    `,
    {
      gamePlayerId: gamePlayer?.id,
    },
    {
      skip: !gamePlayer,
    },
  );

  if (!data?.gamePlayer?.reelViews?.length) {
    return null;
  }

  return (
    <Section title={`HIGHLIGHT REELS`}>
      <Grid gridItemWidth="210px">
        {data?.gamePlayer.reelViews.map((reelView) => (
          <ReelCard key={reelView.id} reelView={reelView} />
        ))}
      </Grid>
    </Section>
  );
}
